import { Capacitor } from '@capacitor/core'
import { isAuthed, isLoaded } from '~/composables/UserState'

const changeTimes = shallowRef(0)

export default defineNuxtRouteMiddleware((to, from) => {
  changeTimes.value++

  // Remove i18n to detect current path better
  let unlocalizedToPath = to.fullPath
  if (unlocalizedToPath.startsWith('/'+useNuxtApp().$i18n.locale.value)){
    unlocalizedToPath = unlocalizedToPath.slice(useNuxtApp().$i18n.locale.value.length + 1)
  }

  // If not loaded and starts with home
  if (
    (!isLoaded.value
    && unlocalizedToPath.startsWith('/home'))
  ) {
    // console.log("['auth.global'] Redirecting to warmup")
    return useLocalePath()('/warmingup?redirect=' + unlocalizedToPath)
  }

  // If not authed and starts with home
  if(
    !isAuthed.value
      && isLoaded.value
      && unlocalizedToPath.startsWith('/home')
  ){
    // console.log("['auth.global'] Redirecting to login")
    return useLocalePath()('/login')
  }

  // if native then only show login/register/forgot-password/confirm-email/imprint
  if (
    !isAuthed.value &&
    Capacitor.getPlatform() !== 'web' &&
    ![
      '/login',
      '/register',
      '/forgot-password',
      '/confirm-email',
      '/imprint',
      '/blog',
      '/privacy',
      '/wiki',
      '/tos'
    ].some(p => to.path.includes(p))
  ) {
    // console.log('Running in Capacitor environment on platform: ' + Capacitor.getPlatform());
    // console.log('Redirecting from: "' + to.path + '"');
    return useLocalePath()('/login');
  }

  // Bring authed user back
  if (
    isAuthed.value
		&& unlocalizedToPath == '/'
  ){
    // console.log("['auth.global'] Redirecting to home")
    return useLocalePath()('/home')
  }

  // Force users to complete setup if is_setup is set to false
  if (
    isAuthed.value
    && user.value.is_setup == false
    && unlocalizedToPath !== '/home/complete-setup'
    && unlocalizedToPath.includes('/home')
    && !(unlocalizedToPath.split('?')[0]).endsWith('/home/complete-setup')
  ){
    console.log("['auth.global'] Redirecting to complete setup", unlocalizedToPath.split('?')[0])
    return useLocalePath()({
      path: '/home/complete-setup',
      query: { ...to.query }
    })
  }

  // If completed setup, then redirect
  if (
    isAuthed.value
    && user.value.is_setup == true
    && unlocalizedToPath == '/home/complete-setup'
  ){
    // console.log("['auth.global'] Redirecting from setup")
    return useLocalePath()('/warmingup?redirect=/home')
  }

  if (isLoaded.value && to.fullPath.includes('warmingup')) {
    // console.log('Already loaded, skipping warmingup')
    return false
  }
})
